import { forwardRef } from 'react';

import { IconProps } from '.';

export const FormChecklistIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" fill="none" ref={ref} {...props} {...{ className }}>
      <path
        fill="currentColor"
        d="M6.5 8.77631C6.5 8.36209 6.83579 8.02631 7.25 8.02631H9.75C10.1642 8.02631 10.5 8.36209 10.5 8.77631C10.5 9.19052 10.1642 9.52631 9.75 9.52631H7.25C6.83579 9.52631 6.5 9.19052 6.5 8.77631Z"
      />
      <path
        fill="currentColor"
        d="M12.25 8.02631C11.8358 8.02631 11.5 8.36209 11.5 8.77631C11.5 9.19052 11.8358 9.52631 12.25 9.52631H12.75C13.1642 9.52631 13.5 9.19052 13.5 8.77631C13.5 8.36209 13.1642 8.02631 12.75 8.02631H12.25Z"
      />
      <path
        fill="currentColor"
        d="M6.5 11.7763C6.5 11.3621 6.83579 11.0263 7.25 11.0263H9.75C10.1642 11.0263 10.5 11.3621 10.5 11.7763C10.5 12.1905 10.1642 12.5263 9.75 12.5263H7.25C6.83579 12.5263 6.5 12.1905 6.5 11.7763Z"
      />
      <path
        fill="currentColor"
        d="M12.25 11.0263C11.8358 11.0263 11.5 11.3621 11.5 11.7763C11.5 12.1905 11.8358 12.5263 12.25 12.5263H12.75C13.1642 12.5263 13.5 12.1905 13.5 11.7763C13.5 11.3621 13.1642 11.0263 12.75 11.0263H12.25Z"
      />
      <path
        fill="currentColor"
        d="M6.5 14.7763C6.5 14.3621 6.83579 14.0263 7.25 14.0263H9.75C10.1642 14.0263 10.5 14.3621 10.5 14.7763C10.5 15.1905 10.1642 15.5263 9.75 15.5263H7.25C6.83579 15.5263 6.5 15.1905 6.5 14.7763Z"
      />
      <path
        fill="currentColor"
        d="M12.25 14.0263C11.8358 14.0263 11.5 14.3621 11.5 14.7763C11.5 15.1905 11.8358 15.5263 12.25 15.5263H12.75C13.1642 15.5263 13.5 15.1905 13.5 14.7763C13.5 14.3621 13.1642 14.0263 12.75 14.0263H12.25Z"
      />
      <path
        fill="currentColor"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.5 16.2763C16.5 17.5189 15.4926 18.5263 14.25 18.5263H5.75C4.50736 18.5263 3.5 17.5189 3.5 16.2763V4.77631C3.5 3.53367 4.50736 2.52631 5.75 2.52631H11.568C12.1648 2.52631 12.7371 2.76336 13.159 3.18532L15.7863 5.81264C16.2242 6.20189 16.5 6.76938 16.5 7.40131V16.2763ZM5 16.2763V4.77631C5 4.36209 5.33579 4.02631 5.75 4.02631H11.5C11.9142 4.02631 12.25 4.36209 12.25 4.77631V6.02631C12.25 6.44052 12.5858 6.77631 13 6.77631H14.375C14.5231 6.77631 14.6592 6.82783 14.7663 6.91394L14.7803 6.92796C14.921 7.06861 15 7.25937 15 7.45829V16.2763C15 16.6905 14.6642 17.0263 14.25 17.0263H5.75C5.33579 17.0263 5 16.6905 5 16.2763Z"
      />
    </svg>
  );
});

export default FormChecklistIcon;
